module.exports = __webpack_public_path__ + "img/3.efb9f417.png";